import React from "react";
import Fonts from "../assets/Fonts";
import Colors from "../assets/Colors";
import classes from "./Checkbox.module.css";
import PropTypes from "prop-types";

export const Checkbox = ({
  value,
  setValue,
  label,
  count,
  subText,
  subTextStyle,
  disabled,
  forwardedRef,
  title,
  checked,
  onClick,
  labelStyle,
  classNameB,
  type = "select",
}) => {
  const isChecked = value?.findIndex((findValue) => findValue == label);
  const HandleClick = () => {
    if (forwardedRef && title) {
      forwardedRef.current = title;
    }
    const newArray = value?.slice();

    if (isChecked !== -1) {
      newArray.splice(isChecked, 1);
    } else {
      newArray.push(label);
    }
    setValue(newArray);
  };
  return (
    <>
      <style jsx>{`
        .${classes.container} input:checked ~ .${classes.checkmark} {
          background-color: ${Colors.neutralShadesOfNero};
        }
        .${classes.container} input:disabled ~ .${classes.checkmark} {
          border: ${isChecked !== -1 ? 0 : 2}px solid #dddddd;
          background-color: ${isChecked !== -1
          ? Colors.neutralShadesOfGainsboro
          : "transparent"};
        }
        .${classes.checkmark} {
          border: 2px solid ${Colors.neutralShadesOfGainsboro};
        }
        .${classes.checkmark}:hover {
          border: 2px solid ${Colors.neutralShadesOfNero};
        }
        .${classes.label} {
          color: ${Colors.neutralShadesOfDimGray};
        }
        .${classes.labelDisabled} {
          color: ${Colors.neutralShadesOfPinkSwan};
        }
        .${classes.labelChecked} {
          color: ${Colors.neutralShadesOfNero};
        }
      `}</style>

      <div className={`my-2 ${classes.checkboxWithLabel}`}>
        <div
          className={`${classes.container} ${classNameB ? classNameB : ""
            }`}
        >
          <input
            type="checkbox"
            checked={checked ? "checked" : isChecked !== -1 && "checked"}
            disabled={disabled}
            id={`checkbox${label}`}
          />
          <span
            className={`${[
              classes.checkmark,
              type == "unselect" && classes.unSelect,
            ].join(" ")}`}
            onClick={() =>
              disabled !== true && (onClick ? onClick(label) : HandleClick())
            }
          ></span>
        </div>
        {label && (
          <label
            htmlFor={`checkbox${label}`}
            className={` ${
              // isChecked !== -1 && disabled == false
              //   ? classes.labelChecked
              //   : disabled == true
              //   ? classes.labelDisabled
              // :
              classes.label
              }`}
            style={{
              ...Fonts.p1,
              color:
                isChecked !== -1 && disabled === false
                  ? Colors.neutralShadesOfNero
                  : disabled == true
                    ? Colors.neutralShadesOfPinkSwan
                    : Colors.neutralShadesOfDimGray,
              ...labelStyle,
            }}
          >
            <span>
              {label} {count && count}
            </span>
            {subText && (
              <span
                style={{
                  color:
                    disabled === true
                      ? Colors.neutralShadesOfDimGray
                      : Colors.neutralShadesOfPinkSwan,
                  ...subTextStyle,
                }}
              >
                {subText}
              </span>
            )}
          </label>
        )}
      </div>
    </>
  );
};

Checkbox.propTypes = {
  value: PropTypes.array,
  setValue: PropTypes.func,
  disabled: PropTypes.bool,
  count: PropTypes.string,
  label: PropTypes.string,
  subTextStyle: PropTypes.object,
  forwardedRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.any }),
  ]),
  title: PropTypes.string,
  labelStyle: PropTypes.object,
};
Checkbox.defaultProps = {
  value: [],
  disabled: false,
  label: null,
};
